export class SurveyLineal{

  questions: any[] = [];

  constructor(){}

}
